import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import TikTokService from 'services/providers/TikTokService';

const TikTokAuthorize = (props) => {
    const [authUrl, setAuthUrl] = useState('');
    const history = useHistory();

    const getData = async () => {
        const r = await TikTokService.getAuthUrl();
        console.log(`authUrl response:`, r)
        if (r?.success && r?.url) {
            setAuthUrl(r.url);
        } else {
            alert('TikTok authorization failed.');
        }
    };

    useEffect(() => {
        if (authUrl) {
            console.log(`Redirecting...`, authUrl)
            window.location.href = authUrl;
        }
    }, [authUrl]);

    useEffect(async () => {
        await getData();
    }, []);

    return <></>;
};

export default TikTokAuthorize;
